import { render, staticRenderFns } from "./studentsAdvantage.vue?vue&type=template&id=198451c2&scoped=true&"
import script from "./studentsAdvantage.vue?vue&type=script&lang=js&"
export * from "./studentsAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./studentsAdvantage.vue?vue&type=style&index=0&id=198451c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198451c2",
  null
  
)

export default component.exports